import { render, staticRenderFns } from "./GCRegister.vue?vue&type=template&id=3aa6ae46&"
import script from "./GCRegister.vue?vue&type=script&lang=js&"
export * from "./GCRegister.vue?vue&type=script&lang=js&"
import style0 from "./GCRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports